import { QPoint } from "../CoreApp/QPoint.js";

export function ConvertPhotoFrameSelection(value) {
  var p = new QPoint();
  var s = value.split(" ");
  p.fX = parseInt(s[0]);
  p.fY = parseInt(s[2]);
  return p;
}
